// Cookie helper a career miniapp számára.
// document.cookie alapú; SSR-safe (typeof document guard).
export function getCookie(name) {
    if (typeof document === 'undefined')
        return null;
    const prefix = encodeURIComponent(name) + '=';
    const parts = document.cookie ? document.cookie.split(';') : [];
    for (let i = 0; i < parts.length; i++) {
        const c = parts[i].trim();
        if (c.indexOf(prefix) === 0) {
            return decodeURIComponent(c.substring(prefix.length));
        }
    }
    return null;
}
export function setCookie(name, value, days) {
    if (typeof document === 'undefined')
        return;
    const safeDays = Math.max(0, Math.floor(days));
    const maxAge = safeDays * 24 * 60 * 60;
    // Nem használunk Secure flag-et: a popup-tracking nem érzékeny adat,
    // és self-signed dev cert mellett a Secure cookie set silent fail-t okozhat.
    // SameSite=Lax elegendő CSRF védelem ehhez.
    const segments = [
        encodeURIComponent(name) + '=' + encodeURIComponent(value),
        'Max-Age=' + maxAge,
        'Path=/',
        'SameSite=Lax',
    ];
    document.cookie = segments.join('; ');
}
